export const RESPONSIBLE_PERSON = 'RESPONSIBLE_PERSON';
export const REPLACEMENT_PERSON = 'REPLACEMENT_PERSON';

export default {RESPONSIBLE_PERSON, REPLACEMENT_PERSON}